import React from "react";

export default function ProfileHighlight(props) {
  return null;
}
